import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SignUpForm from '../../components/forms/SignUpForm';
import { signUp } from '../../store/action/auth'
import { logChannelUser } from '../../store/action/log'
import ReactInterval from 'react-interval';
import { trackEvent } from "../../services/analytics";
import {Helmet} from "react-helmet";
import qs from 'qs';

const SignUp = (props) => {
  const [ values, setValues ] = useState({
    firstName:'',
    lastName:'',
    email:'',
    password:'',
    error:'',
    channel:'',
    success: false,
    loading:false
  });

  const { firstName, lastName, email, password, success, error, channel } = values;

  useEffect(()=> {
    const data = qs.parse(props.location.search, { ignoreQueryPrefix: true })
    setValues({
      ...values,
      firstName:data.first_name,
      lastName:data.last_name,
      email:data.email,
      channel:data.channel ? data.channel.charAt(0).toUpperCase() + data.channel.slice(1) : ''
    })
    if (data.email) {
      logChannelUser({email:data.email,channel:data.channel})
    }
  },[]);

  const handleChange = name => event => {
    setValues({ ...values, error: false, channel:'',[name]: event.target.value });
  };

  const onSubmit = (event) => {
    signUp({firstName, lastName, email, password})
    .then(data => {
      if (data.error) {
        setValues({...values, error:data.error, success:false,loading:false})
      } else {
        trackEvent("User Sign Up",{
          action: "track",
          category: "Users",
          label: 'Sign Up From Website',
          event: "Click"
        });

        setValues({
          ...values,
          firstName:'',
          lastName:'',
          email:'',
          password:'',
          error:'',
          loading:false,
          success: true
        })
      }
    })
  };

  const showError = () => (
    <div
      className="alert alert-danger rounded"
      style={{display: error ? '' : 'none'}}
      >
      { error }
    </div>
  )

  const showSuccess = () => (
    <div
      className="alert alert-info rounded"
      style={{display: success ? '' : 'none'}}
      >
      Telah terbuat user baru. Yuk <Link to="/signin">Login</Link>
    </div>
  )

  const showChannel = () => (
    <div
      className="alert alert-info rounded"
      style={{display: channel ? '' : 'none'}}
      >
      <h5 className="text-white">Hi member {channel}!</h5>
      <p>Selamat datang di Biteship! Yuk buat akun dan kembangkan bisnis kamu dengan fitur pengiriman lengkap!</p>
    </div>
  )

  const onLoading = e => {
    setValues({ ...values, loading:true})
  }

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Biteship: Sign Up</title>
        <meta name="description" content="Enhance your business operation with our platform!" />
        <link rel="canonical" href="https://biteship.com/signup" />
      </Helmet>
      <ReactInterval
        timeout={2000}
        enabled={values.loading}
        callback={() => onSubmit()}
        />
      <div className="peers ai-s fxw-nw h-100vh">
        <div
          className="d-n@sm- peer peer-greed bgpX-c bgpY-c bgsz-cv pos-r"
          style={{
            backgroundImage: 'url("images/bg.jpg")',
            height: '100%!important',
            position: 'relative!important',
            backgroundRepeat: 'no-repeat'
          }}
        >
        </div>
        <div
          className="col-12 col-md-4 peer pX-40 pY-80 h-100 bgc-white scrollable pos-r"
          style={{ minWidth: '320px' }}
        >
          <h2 id="brand-logo">
              <a className="navbar-brand" id="header-logo">
                  <img
                      className="rounded-full" 
                      style={{height:72}}
                      src={"/images/logos/biteship.png"} 
                      alt=""
                  />
              </a>
          </h2>
          { showSuccess() }
          { showError() }
          { showChannel() }
          <SignUpForm
            handleChange={handleChange}
            values={values}
            loading={values.loading}
            onSubmit={onLoading}
            />
        </div>
      </div>
    </div>
  );
};

export default SignUp;
